import { memo, useMemo, useState } from "react";

import Range from "./Range";
import { formatHHMM, formatTimeTo12Hour } from "../../../../utils";
import ArrivalTimeDetails from "../priceCheckDetails/ArrivalTimeDetails";
import JobNeedTimeDescription from "../jobNeedTimeDescription/JobNeedTimeDescription";
import PricingRules from "./PricingRules";
import ArriveWithin from "./ArriveWithin";
import PriceAllDetails from "../priceCheckDetails/PriceAllDetails";

const SelectArrivalRange = ({ 
    range = [0, 0], 
    setRange, 
    calculateFutureTime, 
    subSkill, 
    isHome = false, 
    defaultRange,
    skill,
    jobRatePreHour,
    retryJob,
    stepFlowIsEnable
}) => {
    const [isSliderDisabled, setIsSliderDisabled] = useState(false);

    const [formattedStart, formattedEnd] = useMemo(() => {
        if (!range || range.length < 2) return ["--:--", "--:--"];
        const start = formatHHMM(calculateFutureTime(range[0]));
        const end = formatHHMM(calculateFutureTime(range[1]));
        return [start, end];
    }, [calculateFutureTime, range]);

    if (isHome) {
        return (
            <>
                <Range
                    range={range}
                    setRange={setRange}
                    calculateFutureTime={calculateFutureTime}
                    isHome={isHome}
                    isSliderDisabled={isSliderDisabled}
                />

                <ArriveWithin 
                    defaultRange={defaultRange} 
                    setRange={setRange} 
                    setIsSliderDisabled={setIsSliderDisabled} 
                    isHome={isHome} 
                    range={range}
                    calculateFutureTime={calculateFutureTime}
                    subSkill={subSkill}
                />

                {stepFlowIsEnable && (
                    <PriceAllDetails
                        skill={skill}
                        jobRatePreHour={jobRatePreHour}
                        isCurrentJob={false}
                        isHome={isHome}
                        range={range}
                        calculateFutureTime={calculateFutureTime}
                    />
                )}
            </>
        );
    }

    return (
        <>
            {/* <span className={`badge rounded-pill bg-${theme.main} text-light text-bolder w-50 mt-n3 mx-auto`}>
                Arrival Time
            </span> */}

            <div className="card-header text-center pt-4 pb-3">
                <h3 className="font-weight-bold mt-2">
                    {formattedStart} <small className="text-lg">to</small> {formattedEnd}
                </h3>
            </div>

            <>
                <Range
                    range={range}
                    setRange={setRange}
                    calculateFutureTime={calculateFutureTime}
                    isSliderDisabled={isSliderDisabled}
                />

                <ArriveWithin 
                    defaultRange={defaultRange} 
                    setRange={setRange} 
                    setIsSliderDisabled={setIsSliderDisabled} 
                    isHome={isHome}
                />

                <div className="mt-4">
                    <div className="d-flex justify-content-start p-2">
                        <i className="material-symbols-rounded my-auto">done</i>
                        <span className="ps-3">
                            Arrival window between{" "}
                            <b>
                                {formatTimeTo12Hour(formattedStart)} and {formatTimeTo12Hour(formattedEnd)}
                            </b>
                        </span>
                    </div>
                </div>

                <ArrivalTimeDetails isHome={isHome} />
                {subSkill && <JobNeedTimeDescription sub_skill_id={subSkill?.sub_skill_id}  />}
                <PricingRules isHome={isHome} subSkill={subSkill} range={range} calculateFutureTime={calculateFutureTime} />
            </>
        </>
    );
};

export default memo(SelectArrivalRange);